import axios, { AxiosError } from 'axios';
import Environment from '../../utils/Environment';
import { StoreOrderResponseDTO } from '../../common/tab/dto/StoreOrderResponseDTO';
import { StoreOrderDTO } from '../../common/tab/dto/StoreOrderDTO';
interface ErrorResponse {
  error: string;
  status?: number;
}

const getMsgCount = async (
  form: StoreOrderDTO,
  setIsLoading: (value: boolean) => void,
  setResponse: (value: StoreOrderResponseDTO | ErrorResponse) => void
): Promise<void> => {
  const apiUrl = Environment.getStoreOrderMsgCountAPI();
  setIsLoading(true);

  try {
    const { data } = await axios.post<StoreOrderResponseDTO>(apiUrl, form);
    setResponse(data);
  } catch (err) {
    const error = err as AxiosError;
    const message = error.response?.data || error.message || 'Unknown error';

    setResponse({
      error: typeof message === 'string' ? message : JSON.stringify(message),
      status: error.response?.status,
    });
  } finally {
    setIsLoading(false);
  }
};
export default getMsgCount;